import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Erro capturado no ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", color: "crimson", fontWeight: "bold" }}>
          Algo deu errado. Verifique os dados ou tente novamente.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;